import React from "react";
import "./clients.css";
import clientOne from "../../Media/client1.svg";
import clientTwo from "../../Media/client2.svg";
import clientThree from "../../Media/client3.svg";
import clientFour from "../../Media/client4.svg";
import clientFive from "../../Media/client5.svg";
import clientSix from "../../Media/client6.svg";
import clientSeven from "../../Media/client7.svg";
import clientEight from "../../Media/client8.svg";
import clientNine from "../../Media/client9.png";
import clientTen from "../../Media/client10.png";

const clients = [
  {
    image: clientOne,
    alt: "Splunk PHI/PII Removal Solution Inheritance logo",
  },
  {
    image: clientTwo,
    alt: "Kalaadi King logo",
  },
  {
    image: clientThree,
    alt: "Arya logo",
  },
  {
    image: clientFour,
    alt: "Prime Electricks logo",
  },
  {
    image: clientFive,
    alt: "Al Nada Exchange logo",
  },
  {
    image: clientSix,
    alt: "Dream Catcher logo",
  },
  {
    image: clientSeven,
    alt: "Securing Internal Microservice logo",
  },
  {
    image: clientEight,
    alt: "Noorul Islam College of Arts and Science logo",
  },
  {
    image: clientNine,
    alt: "Kosmos logo",
  },
  {
    image: clientTen,
    alt: "Yazh logo",
  },
];

const Clients = () => {
  return (
    <section className="client-section">
      <div className="client-brief">
        <div className="client-heading">
          <h2 className="client-heading-text who-we-are-animate">
            Our Clients
          </h2>
        </div>
        <div className="client-details">
          <p className="client-details-text who-we-are-animate">
            We are proud to partner with industry leaders
            and innovative businesses worldwide.
          </p>
        </div>
      </div>

      <div className="client-marquee">
        <div className="client-track">
          {[...clients, ...clients].map(
            (client, index) => (
              <div
                className="client-logo-card"
                key={`${client.alt}-${index}`}
              >
                <img
                  src={client.image}
                  alt={client.alt}
                  loading="lazy"
                />
              </div>
            )
          )}

        </div>
      </div>

      <div className="client-marquee client-marquee-reverse">
        <div className="client-track">
          {[...clients, ...clients].map(
            (client, index) => (
              <div
                className="client-logo-card"
                key={`reverse-${client.alt}-${index}`}
              >
                <img
                  src={client.image}
                  alt={client.alt}
                  loading="lazy"
                />
              </div>
            )
          )}
        </div>
      </div>

    </section>
  );
};

export default Clients;